export function scaleIngredients(ingredients, originalServings, targetServings) {
  if (!originalServings || !targetServings || originalServings === targetServings) {
    return ingredients;
  }
  const ratio = targetServings / originalServings;
  return ingredients.map(ing => ({
    ...ing,
    qty: ing.qty ? Math.round(ing.qty * ratio * 100) / 100 : ing.qty,
  }));
}

export function formatQuantity(qty) {
  if (!qty || qty === 0) return '';

  const fractions = {
    0.125: '\u215B',
    0.25: '\u00BC',
    0.33: '\u2153',
    0.375: '\u215C',
    0.5: '\u00BD',
    0.67: '\u2154',
    0.625: '\u215D',
    0.75: '\u00BE',
    0.875: '\u215E',
  };

  const whole = Math.floor(qty);
  const decimal = Math.round((qty - whole) * 1000) / 1000;

  if (decimal === 0) return whole.toString();

  let closestFraction = '';
  let closestDiff = 1;
  for (const [value, symbol] of Object.entries(fractions)) {
    const diff = Math.abs(decimal - parseFloat(value));
    if (diff < closestDiff) {
      closestDiff = diff;
      closestFraction = symbol;
    }
  }

  if (closestDiff < 0.05) {
    return whole > 0 ? `${whole} ${closestFraction}` : closestFraction;
  }

  return qty % 1 === 0 ? qty.toString() : qty.toFixed(2).replace(/\.?0+$/, '');
}
